import { Component, ViewChild, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-demo-video-section',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, RouterModule],
  templateUrl: './demo-video-section.component.html',
  styleUrls: ['./demo-video-section.component.scss']
})
export class DemoVideoSectionComponent {
  @ViewChild('videoPlayer') videoPlayerRef?: ElementRef<HTMLVideoElement>;

  /** Why watch: workflow outcomes, not category labels */
  demoBulletPoints = [
    'See how member records, renewals, and status stay in one system',
    'See how events, registration, and payments tie back to the right member',
    'See how directories and communications stay connected to live data',
    'Understand how reporting works without rebuilding spreadsheets',
  ];

  /** Video file under public/video (served at /video/...) */
  videoSrc = '/video/MT-Demo.mp4';
  /** Optional poster image; leave empty to use video first frame */
  posterSrc = '/video/MT-Demo-poster.webp';
  isPlaying = false;
  videoLoaded = false;

  playVideo() {
    const player = this.videoPlayerRef?.nativeElement;
    if (player) {
      player.play();
      this.videoLoaded = true;
    }
  }
}


